/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../../shared/qrequest";
import Alert from "../../Alert";
import BaseCom from "../../BaseCom";
import L from "../../Lang";
import PaymentCom from "../PaymentCom";

export default class ATHMovil extends PaymentCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {
                processType: 'am',
            }
        }
    }

    async componentDidMount() {
        this.setState({ info: { ...this.state.info } });
        setTimeout(() => {
            this.load();
        }, 500);
        this.validateInterval = setInterval(this.validate, 3000);
    }

    componentWillUnmount() {
        clearInterval(this.validateInterval);
    }

    load = async () => {
        try {
            let j = await qreq.postAsync('/api/merchant/details', this.props.session);
            if (!j.item) { // error out
                this.alert(j.errorMessage);
                return;
            }

            if (!j.item.isATHenable) {
                this.setState({ error: 'ATH Movil is not enabled in this merchant. ' });
                return;
            }

            this.setState({ loaded: true });

            setTimeout(() => {

                //sandboxtoken01875617264
                window.ATHM_Checkout = {
                    env: 'production',
                    publicToken: j.item.athpublickey, // replace with prod
                    timeout: 600,
                    theme: 'btn',
                    lang: 'es',
                    orderType: '',
                    total: this.props.session.total,
                    tax: 0,
                    subtotal: 0,
                    metadata1: 'paradigm',
                    metadata2: 'payment',
                    onCompletedPayment: (response) => {
                        console.log('onCompletedPayment', response);

                        this.submit({
                            referenceNumber: response.referenceNumber,
                            transactionID: response.dailyTransactionID,
                            __amount: response.total
                        });

                    },
                    onCancelledPayment: (response) => {
                        console.log('onCancelledPayment', response);
                    },
                    onExpiredPayment: (response) => {
                        console.log('onExpiredPayment', response);
                    }
                }

                let jqs = document.createElement('script');
                jqs.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
                jqs.async = true;
                jqs.onload = () => {
                    let script = document.createElement('script');
                    script.src = 'https://www.athmovil.com/api/js/v3/athmovilV3.js';
                    script.async = true;
                    script.onload = () => {
                        console.log('ATH Movil loaded.');
                    };
                    document.head.appendChild(script);
                };
                document.head.appendChild(jqs);
            }, 500);
        }
        catch (e) {
            console.error(e);
        }
    }

    validate = async () => {
        /*
        const info = { ...this.props.session, dateTimeStamp: String((new Date()).valueOf()) };
        try {
            let j = await qreq.postAsync('/api/payment/validate/athmovil', info);
            if (j.errorCode === 0) {
                this.props.onSuccess(j.item);
            }
            else if (j.errorCode === 7)
                console.log('ATHMovil Status', j.item);
            else
                this.props.onError(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        */
    }


    submit = async (info) => {
        info = { ...info, ...this.props.session, processType: 'am' };
        info.amount = info.__amount;
        console.log('submit', info);

        this.setState({ submitting: true });
        try {
            let j = await qreq.postAsync('/api/payment/process', info);
            if (j.item)
                this.props.onSuccess(j.item);
            else
                this.props.onError(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }


    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    render() {
        return <div>
            <div className="row">
                <div className="col-md-12">
                    <h2>ATH Movil</h2>
                    {this.state.loaded && <div id="ATHMovil_Checkout_Button"></div>}
                    {this.state.error && <Alert type="danger">{this.state.error}</Alert>}
                </div>
            </div>
            <div className="d-grid my-2">
                <button type="button" className="btn btn-lg" onClick={this.props.onCancel}><L>Select a different Payment Method</L></button>
            </div>
        </div>;
    }
}